<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        @save="$refs.Form.save()"
        extraLarge
        ref="Modal"
        title="Laboratório - Faturamento automático"
    >
        <Form
            :data="data"
            :index="index"
            :item="item"
            @save="handleExit"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Components.
import Form from './Form'

// Mixins.
import { repository, stringCase, object, error } from '@/mixins'

export default {
    components: { Form },
    created() {

        this.repositories = {
            parametrizacao: this.getConectaSusRepository('exameLaboratorial.parametrizacao'),
        }
    },
    data: () => ({
        index: null,
        item: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(index, item) {

            this.index = index
            this.item = item

            if (!item || item.alterado) {

                this.$refs.Modal.show()
            } else {

                this.getFaturamento(item)
            }
        },
        getFaturamento(item) {

            this.setLoading()

            this.repositories.parametrizacao.getLaboratorioFaturamento(this.prepareData(item))
                .then(({ data }) => {

                    this.item.profissionais = data.profissionais
                    this.item.faturamentoRelacionado = data.faturamentoRelacionado
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading(this.$nextTick().then(() => this.$refs.Modal.show())))
        },
        prepareData(item) {

            const infraestruturaId = item.infraestruturaId

            return this.camelObjectKeysToSnakeRecursive({infraestruturaId})
        },
        handleExit(data) {

            this.$emit('save', data)

            this.$refs.Modal.hide()
        },
    },
    mixins: [repository, stringCase, object, error],
    props: {
        data: { type: Object, required: true },
    }
}
</script>